import { render, staticRenderFns } from "./EquipamientoFormHeader.vue?vue&type=template&id=6a582a1e"
import script from "./EquipamientoFormHeader.vue?vue&type=script&lang=js"
export * from "./EquipamientoFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports